module.exports = __webpack_public_path__ + "img/amxmodules.ac8a646c.png";